import * as React from 'react';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete'; // Icône pour Annuler

// Components
import DialogParticipantContent from './DialogParticipantContent';
import Recu from './Recu';
import { initialData } from './AddParticipant';
import BadgeA6 from './BadgeA6';

const customTheme = createTheme({
    palette: {
        primary: { main: "#ED8000", contrastText: "#fff" },
        secondary: { main: "#2E7D32", contrastText: "#fff" },
        error: { main: "#d32f2f" } // Rouge standard Material UI
    },
    components: {
        MuiButton: { styleOverrides: { root: { borderRadius: 8, textTransform: 'none', fontWeight: 'bold' } } },
    }
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': { padding: theme.spacing(2) },
    '& .MuiDialogActions-root': { padding: theme.spacing(2) }, // Un peu plus d'espace en bas
}));

const AddParticipantDialog = ({
    data,
    setData,
    handleChange,
    errors,
    handleSubmit,
    loading,
    showRecu,
    setShowRecu,
    infosVente,
    infosParticipant
}) => {
    const [open, setOpen] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailInvalid = data.email && data.email.trim() !== "" && !emailRegex.test(data.email);

    useEffect(() => {
        const checkValidity = () => {
            const phoneDigits = data.telephone?.replace(/\s/g, '') || "";
            const isEmailValid = !data.email || data.email.trim() === "" || emailRegex.test(data.email);

            const isValid =
                data.nom?.trim().length > 0 &&
                data.prenoms?.trim().length > 0 &&
                !!data.dateNaissance &&
                !!data.genre &&
                phoneDigits.length >= 10 &&
                isEmailValid;

            setIsFormValid(isValid);
        };
        checkValidity();
    }, [data]);

    const handleClickOpen = () => setOpen(true);

    // Cette fonction ferme ET vide le formulaire
    const handleClose = () => {
        setOpen(false);
        setTimeout(() => { setShowRecu(false); setData(initialData); }, 300);
    };

    return (
        <ThemeProvider theme={customTheme}>
            <React.Fragment>
                <Button variant="contained" color="primary" onClick={handleClickOpen} startIcon={<AddIcon />} sx={{ height: 50 }}>
                    Cliquer ici pour vous enregistrer
                </Button>

                <BootstrapDialog
                    onClose={(event, reason) => { if (reason !== 'backdropClick') handleClose(); }}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle sx={{ m: 0, p: 2, color: 'primary.main', fontWeight: 'bold' }}>
                        {showRecu ? "Confirmation d'inscription" : "Nouveau Participant"}
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
                        <CloseIcon />
                    </IconButton>

                    <DialogContent dividers>
                        {showRecu ? (
                            // <Recu data={data} infosVente={infosVente} infosParticipant={infosParticipant} />
                            <BadgeA6 infosParticipant={infosParticipant} />
                        ) : (
                            <DialogParticipantContent
                                data={data}
                                handleChange={handleChange}
                                errors={{ ...errors, email: isEmailInvalid }}
                            />
                        )}
                    </DialogContent>

                    <DialogActions sx={{ justifyContent: showRecu ? 'flex-end' : 'space-between' }}>
                        {showRecu ? (
                            <Button onClick={handleClose} variant="contained" color="primary">Fermer</Button>
                        ) : (
                            // Utilisation d'un Fragment ou Box pour grouper les boutons si besoin
                            <>
                                {/* BOUTON ANNULER */}
                                <Button
                                    onClick={handleClose}
                                    variant="outlined"
                                    color="error" // Rouge
                                    startIcon={<DeleteIcon />} // Ou CloseIcon
                                    disabled={loading}
                                >
                                    Annuler
                                </Button>

                                {/* BOUTON ENREGISTRER */}
                                <Button
                                    onClick={handleSubmit}
                                    disabled={loading || !isFormValid}
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    color="secondary" // Vert
                                    sx={{
                                        px: 4,
                                        "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" }
                                    }}
                                >
                                    {loading ? "Patientez..." : "Enregistrer"}
                                </Button>
                            </>
                        )}
                    </DialogActions>
                </BootstrapDialog>
            </React.Fragment>
        </ThemeProvider>
    );
};

export default AddParticipantDialog;